"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _dialog = _interopRequireDefault(require("../Modal/dialog"));
var _excluded = ["className", "width", "height", "style", "fit", "clickable", "rounded"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Image/index.js";
var defaultProps = {
  width: "100%",
  height: "100%"
};
function Image(_ref) {
  var _this = this;
  var className = _ref.className,
    width = _ref.width,
    height = _ref.height,
    style = _ref.style,
    fit = _ref.fit,
    clickable = _ref.clickable,
    rounded = _ref.rounded,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _style = (0, _objectSpread2["default"])({
    width: width,
    height: height,
    cursor: clickable ? "pointer" : "default"
  }, style);
  var onClick = function onClick() {
    if (clickable) {
      _dialog["default"].fire({
        component: /*#__PURE__*/_react["default"].createElement(Image, Object.assign({}, props, {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 22,
            columnNumber: 25
          }
        })),
        footer: false,
        closable: true
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: _style,
    className: (0, _classNames["default"])(className, "d-flex justify-content-center align-items-center"),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("img", Object.assign({
    onClick: onClick,
    className: (0, _classNames["default"])(fit ? "w-100 h-100" : "mw-100 mh-100", rounded ? "rounded" : ""),
    style: fit ? {
      objectFit: "cover"
    } : {}
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 13
    }
  })));
}
Image.defaultProps = defaultProps;
var _default = exports["default"] = Image;